import * as React from "react";
import {
  ICalendarArchiveListProps,
  ICalendarArchiveListState,
} from "./CalenderArchiveList.types";
import { Icon } from "../Icon/icon";

export class CalendarArchiveList extends React.Component<
  ICalendarArchiveListProps,
  ICalendarArchiveListState
> {
  constructor(props: ICalendarArchiveListProps) {
    super(props);

    this.state = {
      limit: 3,
      LoadMoreHidden: false,
    };
  }

  componentDidMount() {
    this.hideLoadMore();
  }
  componentDidUpdate(prevProps, prevState) {
    this.setFocus(prevState.limit);
  }
  onLoadMore = () => {
    this.setState({
      limit: this.state.limit + 3,
    });

    this.hideLoadMore();
  };
  setFocus = (limit: number) => {
    var contentList = document.querySelectorAll(".calendar-inline__link");
    if (contentList.length > 0) {
      var item = contentList[limit] as HTMLAnchorElement;
      if (item) {
        item.focus();
      }
    }
  };
  hideLoadMore = () => {
    var limitCount = this.state.limit;
    var totalItems = this.props.calenderItemList.length;
    var diffrence = totalItems - limitCount;
    if (diffrence > 0) {
      return this.setState({
        LoadMoreHidden: true,
      });
    } else {
      return this.setState({
        LoadMoreHidden: false,
      });
    }
  };

  renderCalenderList = () => {
    const items = this.props.calenderItemList;
    return items.slice(0, this.state.limit).map((item, index) => {
      var archivedStartdate = item.ArchivedStartdate.split(" ");

      return (
        <div className="col-lg-12" key={index}>
          <div
            key={item.Headline}
            className="calendar-inline calendar-inline--archived-event"
          >
            <time
              className="calendar-inline__date"
              dateTime={item.AttributeDate}
            >
              <div>{item.SpanDate}</div>
              <div>{item.Month}</div>
              <div>{archivedStartdate && archivedStartdate[1]}</div>
            </time>
            <div className="calendar-inline__separator" />
            <div className="calendar-inline__wrapper">
              <a
                className="no-border-link calendar-inline__link"
                href={item.Url}
              >
                {item.Headline}
              </a>
              <div className="calendar-inline__categories calendar-inline--archived-event__categories">
                {item.TagList.map((tag) => (
                  <div
                    key={tag}
                    className="calendar-inline__category text-micro"
                  >
                    {tag}
                  </div>
                ))}
              </div>
              <div className="calendar-inline--archived-event__address-container calendar-inline__location-container">
                <Icon
                  className="calendar-inline__pin"
                  iconType="fontawesome/map-marker-alt-solid"
                  isAriaHidden={false}
                  ariaLabel="Adress"
                />
                <span className="calendar-inline__address text-micro">
                  {item.Address}
                </span>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  render(): JSX.Element {
    return (
      <div className="row">
        <div
          role="log"
          aria-atomic="false"
          className="calendar-inline__container"
        >
          {this.renderCalenderList()}
        </div>
        {this.state.LoadMoreHidden &&
          this.props.calenderItemList.length > this.state.limit && (
            <button
              className="page-list__load-more calendar-pagelist__load-more--archived-pages"
              onClick={this.onLoadMore}
            >
              Ladda mer ({this.props.calenderItemList.length - this.state.limit}{" "}
              kvar)
            </button>
          )}
      </div>
    );
  }
}
